<template>
  <div>
    <CImg
      class="mx-auto d-block w-100 mb-3"
      style="max-width: 100px"
      src="//statics.affili.ir/storage/assets/empty-page.png"
    />
    <span class="h6 text-center d-block">{{ message || $t("pagination.no_filtering_results") }}</span>
  </div>
</template>

<script>
export default {
  name: "EmptyBox",

  props: {
    message: {
      default: null
    }
  }
}
</script>